import { resolveProp } from '@clearscore/helpers.resolve-props';

export const ERR_CONTEXT_NOT_OBJECT = 'Parameter `context` provided was not an object';
export const ERR_VALUES_NOT_OBJECT = 'Parameter `values` provided was not an object';

/**
 * Predicate to evaluate if given item is an object
 * @param {object} item to check
 * @returns {boolean} if item is object
 */
const _isObject = (item) => typeof item === 'object' && item !== null;

/**
 * Predicate to evaluate if given value is a string beginning with @ or #
 * @param {string} val to check
 * @returns {boolean} if item is object
 */
const _shouldLookupProperty = (val) =>
    typeof val === 'string' &&
    (val.startsWith('@') || val.startsWith('?@') || val.startsWith('#') || val.startsWith('?#'));

function _resolveProp(context, value, dictionary) {
    const isContextProp = value.startsWith('#') || value.startsWith('?#');
    const isOptionalProp = value.startsWith('?@') || value.startsWith('?#');
    const prefixLength = isOptionalProp ? 2 : 1;
    const prop = value.substring(prefixLength);
    const resolvedProp = isContextProp ? resolveProp(prop, dictionary) : resolveProp(prop, context);

    if (!resolvedProp) {
        return isOptionalProp ? null : value;
    }
    return dictionary && dictionary[resolvedProp] ? dictionary[resolvedProp] : resolvedProp;
}

/**
 * Look through given values object and attempt to resolve any values beginning with @ from given context
 * @param {Object} context state to resolve values from
 * @param {Object} values object of kv pairs to attempt to resolve
 * @param {Object} dictionary optional lookup for renaming values
 * @returns {Object} values object copy with any possible values interpolated
 */
const interpolateValues = (context, values, dictionary) => {
    if (!_isObject(context)) {
        throw new Error(ERR_CONTEXT_NOT_OBJECT);
    }

    if (!_isObject(values)) {
        throw new Error(ERR_VALUES_NOT_OBJECT);
    }

    return Object.keys(values).reduce((accum, propName) => {
        const value = values[propName];
        const resolvedPropertyValue = _shouldLookupProperty(value) ? _resolveProp(context, value, dictionary) : value;
        return {
            ...accum,
            [propName]: resolvedPropertyValue || accum[propName],
        };
    }, {});
};

export default interpolateValues;
